import Conexion_api from "@/api/Conexion_api.js";

const obtener_contrasenia_usuario = function(distribuidor, rut){
    return new Promise((resuelve,rechaza) => {
    Conexion_api({
        body: {
            base_config: distribuidor.base,        
            rut: rut
        },
        evento: "login/obtener_contrasenia_usuario"
    }).then(respuesta => {
        if(respuesta.data.error){
            this.mostrar_loader = false;
            this.$root.$emit("snackbar", { mostrar: true, color: "error", texto: respuesta.data.error });
            return rechaza(respuesta.data.error);
        }
        if (respuesta.data.contrasenia) {
          distribuidor.contrasenia_usuario = respuesta.data.contrasenia
        }
        return resuelve(true);
    }).catch(err => {
        err = String(err);
        console.error(err);
        this.mostrar_loader = false;
        this.$root.$emit("snackbar", { mostrar: true, color: "error", texto: err });
        return rechaza(err);
    })  
    })
}
export default obtener_contrasenia_usuario